<template>
  <v-dialog persistent overlay-opacity=".7" v-model="internalValue" max-width="55%" class="rounded-lg"
    style="z-index:99999 !important">
    <v-card class="elevation-0 py-5 px-10">
      <div v-html="formattedTextInfo" class="mx-auto text-center pa-5" />
      <div>
        <v-checkbox v-model="checkList" class="mx-4 px-4" label="Concordo com os termos"></v-checkbox>
      </div>
      <div class="d-flex align-center justify-space-between my-2 elevation-0 ">
        <v-btn @click="handleUserSignUp(true)" :disabled="!checkList" class="mx-4" color="primary">{{
          $t('instructions.confirmAndAccept') }}</v-btn>
        <v-btn @click="handleUserSignUp(false)" class="mx-3" outlined color="red">{{ $t('instructions.notAccepted')
          }}</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import convertToCNPJ from "@/utils";

export default {
  name: "AcknowledgeModal",
  props: {
    value: { type: Boolean, required: true },
    tosUserInfo: { type: Object },
  },
  data() {
    return {
      pdfUrl: "/pdf/tos_blank.pdf",
      checkList: false,
      checkSnackBar: false,
      brokerId: null,
    };
  },
  watch: {
    checkList(v) {
      this.checkSnackBar = v;
    }
  },
  methods: {
    handleUserSignUp(val) {
      this.$emit("userAction", val);
    },
    downloadFile() {
      const filename = `FX Partner - Service Agreement.pdf`;
      const link = document.createElement('a');
      link.href = this.pdfUrl
      link.download = filename
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  },
  computed: {
    handlePdfUpload() {
      if (this.tosUserInfo.role === 'partner') {
        this.pdfUrl = "/pdf/30.10-tos-partner-watermark.pdf#toolbar=0&navpanes=0&scrollbar=0&zoom=120"

      }
      return `${this.pdfUrl}#toolbar=0&navpanes=0&scrollbar=0&zoom=120`
    },
    formattedTextInfo() {
      const isBroker = this.tosUserInfo.role === "partner" || this.tosUserInfo.role === 'broker';
      const info = this.tosUserInfo;
      if (!info) return '';
      const formattedCnpj = info.cnpj ? convertToCNPJ(info.cnpj) : '-'
      const name = info.name?.trim() || info.companyName?.trim()

      const termsText = info.role === 'partner' ? `
            <a 
            href="${this.handlePdfUpload}"
            download="Contrato de Usuário e Acesso Eletrônico.pdf"
            style="border-bottom: 1px solid #0073ff; cursor: pointer; text-decoration:none"
               >
            termos para uso e acesso eletrônico
            </a> `
            : 'termos para uso e acesso eletrônico';
      
      return `
      <span class="mt-2 text-body-1 text-info">
          Declaro que li, compreendi e aceito os
      ${termsText} a esta plataforma, incluindo
        seus recursos de negociação, informações e dados de mercado,
          ferramentas analíticas, algoritmos, mensagens, conteúdos e
        demais funcionalidades.</br>
          E-mail: ${info.email ? "<b>" + info.email + "</b>, " : ""}</br>
          Empresa: <b>${name}</b> (<b>${formattedCnpj}</b>)
        </span>
      `;

    },
    toggleCheckList() {
      return this.checkList;
    },
    internalValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("update:value", v);
      },
    },
  },
};
</script>

<style>
.v-dialog {
  scrollbar-width: none;
}

.snackbar-margin {
  position: absolute;
  top: 45%;
}
</style>
<style scoped>
::v-deep .text-info {
  font-size: 1.3rem !important;
  line-height:1.5;
}
</style>
